// Informacion tecnica de solo lectura que acompana a cada solicitud.
import dayjs from "dayjs";
import { getTituloVista } from "../navigation/tituloVista";

// Las pantallas de detalle marcan la pestaña activa con `cd-tab-btn-active`;
// los modales con antd Tabs (p. ej. la cita) usan `ant-tabs-tab-active`. Se toma
// el ultimo coincidente porque los modales se montan al final del DOM.
const SELECTORES_TAB_ACTIVA = [".ant-tabs-tab-active", ".cd-tab-btn-active"];

export function leerPestanaActiva() {
  for (const sel of SELECTORES_TAB_ACTIVA) {
    const els = document.querySelectorAll(sel);
    const el = els[els.length - 1];
    const limpio = (el?.textContent || "").replace(/\s+/g, " ").trim();
    if (limpio) return limpio;
  }
  return "";
}

// Version de la app: REACT_APP_VERSION en el build, o la que exponga Electron.
// CRA no permite importar package.json desde src.
const versionApp = () =>
  process.env.REACT_APP_VERSION || window.electronAPI?.version || "No disponible";

export function recolectarInfoTecnica(pathname) {
  return {
    ruta: pathname,
    tituloVista: getTituloVista(pathname),
    pestanaActiva: leerPestanaActiva(),
    usuario: localStorage.getItem("email") || "",
    rol: localStorage.getItem("role") || "",
    fechaHora: dayjs().format("YYYY-MM-DD HH:mm:ss"),
    resolucionCorta: `${window.innerWidth}x${window.innerHeight}`,
    resolucion: `${window.innerWidth}x${window.innerHeight} (pantalla ${window.screen.width}x${window.screen.height}, escala ${window.devicePixelRatio || 1})`,
    versionApp: versionApp(),
  };
}

export const construirMigas = (info) => [info.tituloVista, info.pestanaActiva].filter(Boolean);
